import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from './user.service';
import { EPagesPath } from '../../app.routes';
import { catchError, map, of } from 'rxjs';

export const contentEditAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.verifyContentEditAccess().pipe(
    map(hasAccess => {
      if (hasAccess) {
        return true;
      } else {
        router.navigate([EPagesPath.home]);
        return false;
      }
    }),
    catchError(() => {
      router.navigate([EPagesPath.home]);
      return of(false);
    })
  );
};
